import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { CellButton } from './styled';
import { Cell } from '../styled';
const Content = styled.div.withConfig({ displayName: "vui--Content", componentId: "vui--1win89s" }) `text-align:inherit;border-bottom:1px dotted black;`;
export const EditableCell = (_a) => {
    var { onClick, children } = _a, otherProps = __rest(_a, ["onClick", "children"]);
    return (React.createElement(Cell, Object.assign({}, otherProps),
        React.createElement(CellButton, { onClick: onClick },
            React.createElement(Content, null, children))));
};
//# sourceMappingURL=EditableCell.js.map